<template>
	<!-- 
		UI Input handler

		Version 1.11
		Corrige un error que obligaba el valor default desde una edición desde fuera del modal.

		Version 1.10
		Corrige un error que impedía la precarga desde el componente default del valor 
		de la propiedad.

		Version 1.9
		Ajustes para el formato de "selectmultiple"

		Version 1.8
		Permite el formato de "selectmultiple"

		Version 1.7
		Corrección de prelectura de requerimiento

		Version 1.6
		Added percent form model

		Version 1.5
		bFormSelect utiliza la propiedad disabled cuando vienen en modo readonly

		Version 1.4
		Actualiza el valor de workingValue en función de value de manera automática

		Version 1.3
		Permite markdown (Requiere simplemde, marked)

		Version 1.2
		Permite positivos únicamente


		Version 1.1

		Permite checkbox

		Version 1.0

		Date: 01/03/2022
		Author: Daniel Lepe
	-->
	<div class="ui-input-handler">

		<b-form-group v-if="fArch.key != 'id' && fArch.type != 'checkbox' && fArch.type != 'markdown'" :label="finalLabel" :label-for="currentId">
			
			<b-form-textarea :id="currentId" v-model="workingValue" v-if="fArch.type == 'textarea'" :readonly="fArch.readonly"/>

			<b-form-select :id="currentId" v-model="workingValue" v-else-if="fArch.type == 'select' || fArch.type == 'selectmultiple'" :multiple="fArch.type == 'selectmultiple'" :disabled="fArch.readonly" :options="fArch.options"/>
				
			<b-form-datepicker :id="currentId" v-model="workingValue" v-else-if="fArch.type == 'datetime'" locale="es" :readonly="fArch.readonly" :disabled="fArch.readonly"/>
			
			<img-input-autoload :id="currentId" v-model="workingValue" v-else-if="fArch.type == 'image'" :readonly="fArch.readonly" :disabled="fArch.readonly" label="false"/>
				
			<b-input-group prepend="$" v-else-if="fArch.type == 'price'" :label="finalLabel" :label-for="currentId">
				<b-form-input :id="currentId" v-model="workingValue" type="number"  :readonly="fArch.readonly" :min="fArch.min"/>
			</b-input-group>

			<b-input-group append="%" v-else-if="fArch.type == 'percent'" :label="finalLabel" :label-for="currentId">
				<b-form-input :id="currentId" v-model="workingValue" type="number"  :readonly="fArch.readonly" :min="fArch.min"/>
			</b-input-group>
			
			<b-form-input :id="currentId" v-model="workingValue" v-else-if="fArch.type == 'positive'" type="number" :min="0" :readonly="fArch.readonly" :minlength="fArch.minlength" :maxlength="fArch.maxlength"/>
			
			<b-form-input :id="currentId" v-model="workingValue" v-else :type="!!(fArch.type)? fArch.type : null" :readonly="fArch.readonly" :minlength="fArch.minlength" :maxlength="fArch.maxlength"/>

		</b-form-group>

		<b-form-checkbox :id="currentId" v-if="fArch.key != 'id' && fArch.type == 'checkbox' && fArch.type != 'markdown'" :name="fArch.key" v-model="workingValue" value="1" unchecked-value="0">
			{{finalLabel}}
		</b-form-checkbox>

		<div v-if="fArch.key != 'id' && fArch.type == 'markdown'">
			<textarea :id="currentId" v-model="workingValue"></textarea>
		</div>

	</div>
</template>

<script>

	import _ from 'lodash'
	import 'simplemde/dist/simplemde.min.css'
	import SimpleMDE from 'simplemde'
	import imgInputAutoload from './img-input-autoload.vue';


	const capitalize = (str) => {
		if (typeof str === "string") {
			return str.replace(/^\w/, (c) => c.toUpperCase());
		} else {
			return "";
		}
	}

	export default {
		components: { imgInputAutoload },
		name: "UIInputHandler",
		props: {
			value: {
				type: [Object, String, Number, Boolean, Array]
			},
			source: {
				type: [Array, Object],
				default: () => {return []}
			},
			fArch: {
				type: [Object],
				default: () => {
					return {
						key: 'indefined',
						type: null,
						label: null,
						default: null,
						readonly: null,
					};
				},
			}
		},
		data: () => {
			return {
				workingValue: null,
				activeSource: {},
				SimpleMDE: null
			}
		},
		watch: {
			value(){
				if(this.fArch.type == 'selectmultiple' && this.value == null) this.workingValue = []
				else if(this.fArch.type == 'selectmultiple' && _.isString(this.value)) this.workingValue = this.value.split(',')
				else if(!!this.fArch.default && this.value == null) this.workingValue = _.clone(this.fArch.default)
				else this.workingValue = _.clone(this.value)
			},
			workingValue(){
				if(this.fArch.type == 'selectmultiple' && _.isArray(this.workingValue))
					this.$emit('input', this.workingValue.join())
				else 
					this.$emit('input', this.workingValue)
			}
		},
		computed: {
			currentId () {
				return 'form-' + this.fArch.key
			},
			simpleLabel(){
				return !!(this.fArch.label)? this.fArch.label : this.automateLabel(this.fArch.key)
			},
			finalLabel(){
				return ((this.activeSource.required && !this.activeSource.readonly)? '* ' : '') + this.simpleLabel
			}
		},
		methods: {
			loadMarkDown(){

				this.SimpleMDE = new SimpleMDE({ 
					initialValue: this.workingValue,
					element: document.getElementById(this.currentId), 
				})
				
				this.SimpleMDE.codemirror.on("change", (ab, inst) => {
					this.workingValue = this.SimpleMDE.value()
				});
			},	
			isReadOnly(){
				return (this.fArch.readonly)
			},
			automateLabel(keyToName) {

				let labelName = null;
				labelName = capitalize(keyToName.replace(/\_/g, " "));

				switch (keyToName) {
					case "created":
						labelName = "Creación";
						break;
					case "modified":
						labelName = "Última edición";
						break;
				}

				return labelName;
			}
		},
		beforeMount(){
			this.workingValue = _.clone(this.value)
			let activeSource = _.find(this.source, {name: this.fArch.key})
			this.activeSource = (!!activeSource) ? activeSource : {}

			if(!!this.activeSource)
				this.fArch.required = this.activeSource.required

			if(this.fArch.type == 'markdown')
				this.loadMarkDown()
		}
	};
</script>

